import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsFilled, IoniconsOutline} from '@pt/pt-models';
import {
  WidgetPreliminaryRiskAssessmentCheckedValueV0,
  WidgetPreliminaryRiskAssessmentPreviewV0
} from '../models/widget-preliminary-risk-assessment-preview-v0';
import {WidgetUtils} from '../../../widget.utils';

@Component({
  selector: 'pt-widget-preliminary-risk-assessment-v0-table',
  templateUrl: './widget-preliminary-risk-assessment-v0-table.component.html',
  styles: [`
    .risk-title {
      margin-bottom: 0;
      font-weight: bold;
    }

    .risk-description {
      margin-bottom: 8px;
    }

  `]
})
export class WidgetPreliminaryRiskAssessmentV0TableComponent {
  @Input() noDataLabel?: string;

  @Input() valutations: WidgetPreliminaryRiskAssessmentPreviewV0[];
  @Input() preview: boolean;

  @Output() changeValutations = new EventEmitter<WidgetPreliminaryRiskAssessmentPreviewV0[]>();

  idPrefix = WidgetUtils.generateId('pra_');
  IconRadiobutton = IoniconsFilled.radiobutton;
  IconCheck = IoniconsOutline.check;
  IconClose = IoniconsOutline.close;

  F = WidgetPreliminaryRiskAssessmentCheckedValueV0.FALSE;
  T = WidgetPreliminaryRiskAssessmentCheckedValueV0.TRUE;

  checkRow(row: WidgetPreliminaryRiskAssessmentPreviewV0, value: boolean) {
    const val = JSON.parse(JSON.stringify(this.valutations));
    val.forEach((r) => {
      if (r.uuid && row.uuid && r.uuid === row.uuid) {
        r.checked = value ? this.T : this.F;
      }
    });
    this.changeValutations.emit(val);
  }

}
